// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"4064":"d705c6035cf8153b","5136":"f2afc1176a36691f","6072":"a8e86a89903482be","6966":"1dbebac4082a56c6"}[chunkId] + ".js";
};